import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from 'components/ui/Typography';
import { TypographyProps } from 'components/ui/Typography/Typography';

import css from './TruncatedText.module.scss';

interface Props extends TypographyProps {
    length?: number;
    children?: string;
    moreAction?: () => void;
}

const TruncatedText: React.FC<Props> = ({ length = 255, children, moreAction, ...rest }) => {
    const { t } = useTranslation();

    const [showMore, setShowMore] = useState(false);

    if (!children) return null;

    const isTextTruncated = children.length > length;
    const visibleText = isTextTruncated ? children.slice(0, length) : children;
    const hiddenText = isTextTruncated ? children.slice(length) : '';

    return (
        <Typography tag="span" className={css.text} {...rest}>
            {visibleText}
            {children.length > length &&
                (showMore ? (
                    hiddenText
                ) : (
                    <span
                        className={css.truncatedTextShowMore}
                        onClick={() => (moreAction ? moreAction() : setShowMore(true))}
                    >
                        <span className={css.truncatedTextShowMoreText}>{t('Common.More')}</span>
                    </span>
                ))}
        </Typography>
    );
};

export default React.memo(TruncatedText);
